(function (window, document) {
    // set up Partially as a global object
    if (!window.Partially) {
        window.Partially = {};
    }

    window.Partially.GhostSearch = function ghostSearch(tag) {
        const searchContainer = document.querySelector(".site-search");
        const searchInput = document.querySelector(".search-input-wrapper input");
        const resultsContainer = document.querySelector(".search-results");
        let resultItems = [];
        let resultItemElements = [];
        let focusedItemIndex = 0;
        let keysBound = false;

        let ghostSearchProps = {
            host: "",
            url: location.origin,
            key: "3f63e4ce73cbc001550bb2e728",
            version: "v2",
            input: "#ghost-search-input",
            results: "#ghost-search-results",
            button: "",
            development: false,
            defaultValue: "",
            template: function (result) {
                let url = [location.protocol, "//", location.host].join("");
                return tag
                    ? `<a class="result-item" href="${ url }/${result.slug}/"><div class="name">${result.title}</div></a>`
                    : `<a class="result-item" href="${ url }/${result.slug}/"><small class="category">${result.tags[0].name} </small><div class="name">${result.title}</div></a>`;
            },
            trigger: "focus",
            options: {
                keys: ["title"],
                limit: 10,
                threshold: -3500,
                allowTypo: false
            },
            api: {
                resource: "posts",
                parameters: {
                    limit: "all",
                    fields: ["title", "slug"],
                    filter: tag ? `tag:${tag.split(" ")[0].toLowerCase()}` : "",
                    include: "tags",
                    order: "",
                    formats: "",
                },
            },
            on: {
                beforeDisplay: function () {
                    searchContainer.classList.add("active");
                    document.body.classList.add("no-scroll");
                },
                afterDisplay: function (results) {
                    resultItems = results;
                    resultItemElements = document.querySelectorAll(".search-results .result-item");
                    // console.log("After Display: ",results);
                    // console.log(results.length, searchInput.value);

                    if (!results.length && searchInput.value.length) {
                        searchContainer.classList.add("empty");
                    }
                    if (!results.length && !searchInput.value.length) {
                        searchContainer.classList.remove("active");
                        searchContainer.classList.remove("empty");
                    }
                    if (results.length) {
                        searchContainer.classList.add("active");
                        document.body.classList.add("no-scroll");
                        searchContainer.classList.remove("empty");
                    }
                    setFocusedItem(focusedItemIndex);
                },
                beforeFetch: function () {
                },
                afterFetch: function (results) {
                }
            }
        };

        let ghostSearch = new GhostSearch(ghostSearchProps);

        function setFocusedItem(focusedIndex) {
            resultItemElements.forEach(function (el, i) {
                // console.log(el, i);
                if (i + 1 === focusedIndex) {
                    el.classList.add("focused");
                    ensureIsVisible(el);
                }
            });
        }

        function clickFocusedItem(focusedIndex) {
            resultItemElements.forEach(function (el, i) {
                // console.log(el, i);
                if (i + 1 === focusedIndex) {
                    el.click();
                }
            });
        }

        function ensureIsVisible(elem) {
            const bounding = elem.getBoundingClientRect();
            const resultsContainerRect = resultsContainer.getBoundingClientRect();
            const distance = {
                top: bounding.top - resultsContainerRect.top,
                left: bounding.left - resultsContainerRect.left,
                bottom: bounding.bottom - resultsContainerRect.bottom,
                right: bounding.right - resultsContainerRect.right
            };

            if (distance.bottom > 0) {
                resultsContainer.scrollBy(0, distance.bottom + parseFloat(window.getComputedStyle(resultsContainer).paddingBottom));
            } else if (distance.top < 0) {
                resultsContainer.scrollBy(0, distance.top - parseFloat(window.getComputedStyle(resultsContainer).paddingTop));
            }
            let isWithin = bounding.top >= resultsContainerRect.top && bounding.left >= resultsContainerRect.left && bounding.bottom <= resultsContainerRect.bottom && bounding.right <= resultsContainerRect.right;
            return isWithin;
        }

        function initialize() {
            searchInput.addEventListener("focus", function () {

                //Add Key Binds
                if (!keysBound) {
                    keysBound = true;
                    document.addEventListener("keydown", function (e) {
                        const DOWN = 40;
                        const UP = 38;
                        const ENTER = 13;

                        if (e.keyCode === DOWN) {
                            focusedItemIndex++;
                        } else if (e.keyCode === UP) {
                            focusedItemIndex--;
                        } else if (e.keyCode === ENTER) {
                            clickFocusedItem(focusedItemIndex);
                        }
                        if (focusedItemIndex > resultItems.length) {
                            focusedItemIndex = 1;
                        } else if (focusedItemIndex <= 0) {
                            focusedItemIndex = resultItems.length;
                        }
                    })
                }
            });

            searchInput.addEventListener("blur", function () {
                searchContainer.classList.remove("active");
                document.body.classList.remove("no-scroll");
            });
        }

        initialize();
    }

})(window, document);
